export const INSIGHT_ACTION_ID_PREFIX = 'rovo-insight';

export type OpenInsight = {
	agentMessageAdf: string;
	title: string;
	followUps: string[];
};
